<template>
  <div class="row">
    <div class="col-lg">
      <h2>Add User</h2>
    </div>
    <div class="col-md-12">
      <div class="col-lg-12 text-center">
        <h2>Please fill in the form below</h2>
      </div>

      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Employee Details</h3>
              <base-input
                label="First Name"
                type="text"
                v-model="fname"
              ></base-input>
              <base-input
                label="Last Name"
                type="text"
                v-model="lname"
              ></base-input>
              <base-input
                label="Telephone No."
                type="text"
                v-model="telno"
              ></base-input>
              <base-input
                label="Email"
                type="email"
                v-model="email"
              ></base-input>
              <base-input label="Address" type="text" v-model="address">
                <textarea class="address"></textarea>
              </base-input>
            </div>
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Company Details</h3>
              <base-input
                label="Employee ID"
                type="text"
                v-model="empid"
              ></base-input>
              <base-input
                label="Password"
                type="password"
                v-model="passwd"
              ></base-input>
              <base-input label="Module access list" type="text">
                <el-select v-model="moduleaccess" multiple placeholder="Select">
                  <el-option
                    v-for="item in moduleList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </base-input>
              <div class="row">
                <div class="col">
                  <base-input label="Department" type="text">
                    <el-select
                      class="select-default"
                      size="large"
                      placeholder="Choose..."
                      v-model="deptid"
                    >
                      <el-option
                        v-for="dept in deptList"
                        :value="dept.DeptID"
                        :label="dept.DeptName"
                        :key="dept.DeptID"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col">
                  <base-input label="Designation" type="text">
                    <el-select
                      class="select-default"
                      size="large"
                      placeholder="Choose..."
                      @change="checkDisable()"
                      v-model="posid"
                    >
                      <el-option
                        v-for="post in postList"
                        :value="post.PosID"
                        :label="post.PosName"
                        :key="post.PosID"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input label="User role" type="text">
                    <el-select
                      class="select-default"
                      size="large"
                      placeholder="Choose..."
                      v-model="roleid"
                    >
                      <el-option
                        v-for="roles in rolesList"
                        :value="roles.RoleID"
                        :label="roles.RoleName"
                        :key="roles.RoleID"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
                <div class="col">
                  <base-input label="User Reported To" type="text">
                    <el-select
                      class="select-default"
                      size="large"
                      :disabled="disablereport"
                      placeholder="Choose..."
                      v-model="managerid"
                    >
                      <el-option
                        v-for="emp in managerList"
                        :value="emp.empid"
                        :label="emp.empname + ' (' + emp.posname + ')'"
                        :key="emp.empname"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </div>

              <base-input label="Status" type="text">
                <el-select
                  class="select-default"
                  size="large"
                  placeholder="Choose..."
                  v-model="statid"
                >
                  <el-option
                    v-for="stat in statList"
                    :value="stat.StatusID"
                    :label="stat.StatusName"
                    :key="stat.StatusID"
                  ></el-option>
                </el-select>
              </base-input>
            </div>
          </div>
        </form>
      </card>
      <div class="col-lg-12 text-center">
        <!-- <base-button 
          @click="modalsCSV = true"
          class="mt-3"
          native-type="submit"
          type="green"
          simple
        >Import with CSV</base-button>&nbsp; -->
        <el-link href="./img/csv/UserRegistration.csv" class="mt-3" type="primary">Download CSV template</el-link>
        &nbsp;
        <span
          class="btn btn-simple btn-green btn-file"
          style="margin-bottom: 0%; margin-top: 0.7%"
        >
          <span class="fileinput-new">Import with CSV</span>
          <input type="file" @change="importCsv" />
        </span>

        <!-- </span> -->
        &nbsp;
        <base-button
          class="mt-3"
          native-type="submit"
          type="primary"
          @click="submitData('FORM')"
          >Submit</base-button
        >
      </div>
      <div class="d-flex justify-content-center spinner" v-if="load">
        <circle-8></circle-8>
      </div>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { Select, Option, Link } from "element-ui";
import { touches } from "d3";
import swal from "sweetalert2";

export default {
  components: {
    BaseCheckbox,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    [Link.name]: Link
  },
  data() {
    return {
      disablereport: false,
      csvdata: [],
      moduleaccess: [],
      address: "",
      telno: "",
      statid: 1,
      email: "",
      posid: "",
      empid: "",
      fname: "",
      lname: "",
      passwd: "",
      roleid: "",
      deptid: "",
      managerid: "",
      postList: "",
      moduleList: "",
      allPosition: "",
      statList: "",
      deptList: "",
      managerList: "",
      sorokRoot: "",
      rolesList: "",
      radios: {
        radio1: "1",
        radio2: "2",
        radio3: "2",
        radioOn: "2",
        radioOff: "2"
      }
    };
  },
  mounted() {
    this.getDeptList();
    this.getRoleList();
    this.getPostList();
    this.getStatList();
    this.getMangerList();
    this.getModuleList();
  },
  methods: {
    checkDisable() {
      this.postList.map(a => {
        if (this.posid == a.PosID) {
          if (a.PosName.toUpperCase().startsWith("CHIEF")) {
            this.managerList.push(this.sorokRoot);
            this.disablereport = true;
            this.managerid = 1;
          } else if (a.PosName.toUpperCase().startsWith("HEAD")) {
            this.allPosition.map(b => {
              if (b.posname.startsWith("CHIEF")) {
                this.managerList = [];
                this.managerList.push(b);

                this.disablereport = false;
                this.managerid = "";
              }
            });
          } else {
            this.managerList = [];
            this.managerList = this.allPosition;
            this.disablereport = false;
            this.managerid = "";
            // this.managerList.pop();
          }
        }
      });
    },
    importCsv(data) {
      console.log(data);
      const file = data.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = e => {
        const userDetails = [
          "id",
          "name",
          "password",
          "phone",
          "address",
          "role",
          "designation",
          "department",
          "manager",
          "accesslist"
        ];

        let header;
        let lines = [];
        let csv = e.target.result; // Content from file
        // console.log(csv);
        let allTextLines = csv.split(/\r\n|\n/);
        // console.log(allTextLines);
        for (let i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        console.log(lines);
        lines.pop();

        if (
          header[0] !== "id" ||
          header[1] !== "name" ||
          header[2] !== "password" ||
          header[3] !== "phone" ||
          header[4] !== "address" ||
          header[5] !== "role" ||
          header[6] !== "designation" ||
          header[7] !== "department" ||
          header[8] !== "manager" ||
          header[9] !== "accesslist"
        ) {
          swal({
            title: "Header Error!",
            html:
              '<b>Make sure you follow the predefined header as below:</b><img width="100%" height="100%" src="img/user-csv.PNG">',
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false
          });
        } else {
          let error = [];
          let err = false;
          let msg = "";
          lines.forEach((line, index) => {
            console.log("USER: ", line[0])
            let mlist = [];
                console.log(line[1])
            for (let i = 0; i < 1; i++) {
              this.managerList.map(a => {

                // console.log("MANAGER: ",a.empname)
                if (a.empname == line[8]) {
                  // console.log("jumpa");
                  line[8] = a.empid;
                } else {
                  // line[8] = 0;
                }
              });

              
              if (Number.isInteger(line[8])) {
                
                this.postList.map(a => {
                  if (a.PosName == line[6]) {
                    line[6] = a.PosID;
                  } else {
                    // line[6] = 0;
                  }
                });

                if (Number.isInteger(line[6])) {

                  this.deptList.map(a => {
                    if (a.DeptName == line[7]) {
                      line[7] = a.DeptID;
                    } else {
                      // line[7] = 0;
                    }
                  });

                  console.log("ROLE: ",line[7])
                  if (Number.isInteger(line[7])) {
                    this.rolesList.map(a => {
                      console.log(a.RoleName);
                      if (a.RoleName == line[5]) {
                        line[5] = a.RoleID;
                      } else {
                        // line[5] = 0;
                      }
                    });

                    if (Number.isInteger(line[5])) {
                      let acc = line[9].split(";");
                      console.log(acc.length);
                      this.moduleList.map(a => {
                        acc.map(b => {
                          if (a.name == b) {
                            mlist.push(a.id);
                          }
                        });
                      });
                    } else {
                      error.push("Invalid role name on line " + index);
                    }
                  } else {
                    error.push("Invalid depeartment name on line " + index);
                  }
                } else {
                  error.push("Invalid designation name on line " + index);
                }
              } else {
                error.push("Invalid manager name on line " + index);
              }

              if (error.length == 0) {
                this.csvdata.push({
                  empid: parseInt(line[0]),
                  empname: line[1],
                  emppassword: line[2],
                  empphone: line[3],
                  empaddr: line[4],
                  roleid: parseInt(line[5]),
                  posid: line[6],
                  deptid: line[7],
                  statusid: 1,
                  managerid: line[8],
                  accessmodule: mlist
                });
              }
            }
          });

          if (error.length > 0) {
            let e = [];
            error.map(a => {
              e.push("<br>" + a + "</br>");
              console.log(e)
            });
            console.log(e.join(""));
            swal({
              title: "Data Error!",
              html: e.join(""),
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
          }else {
               // console.log(this.csvdata);
          this.csvdata = JSON.parse(JSON.stringify(this.csvdata));
          this.submitData("CSV");
          }
         
        }
      };
    },

    submitData(ctx) {
      //get role list
      let finalpayload = "";
      console.log(this.csvdata);
      if (ctx === "FORM") {
        console.log("CALLED REGISTER");
        finalpayload = {
          userlist: [
            {
              empid: parseInt(this.empid),
              empname: this.fname + " " + this.lname,
              emppassword: this.passwd,
              empphone: this.telno,
              empaddr: this.address,
              roleid: this.roleid,
              posid: this.posid,
              deptid: this.deptid,
              statusid: parseInt(this.statid),
              managerid: this.managerid,
              accessmodule: this.moduleaccess
            }
          ]
        };
      } else {
        console.log("CALLED CSV DATA");
        console.log("BEFORE: ", this.csvdata);

        finalpayload = {
          userlist: this.csvdata
        };
      }

      console.log(this.moduleaccess);
      console.log(finalpayload);
      this.$http.post(":9992/api/v1/admin/user", finalpayload).then(res => {
        console.log(res);
        if (!res.error) {
          swal;
          swal({
            title: "Success!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          }).then(result => {
            if (result.value) {
              this.$router.push("/UserManagement");
            }
          });
        } else {
          swal({
            title: "Error!",
            text: res.message,
            type: "error",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    getModuleList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/module").then(res => {
        console.log(res);
        if (!res.error) {
          this.moduleList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    getStatList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/status").then(res => {
        console.log(res);
        if (!res.error) {
          this.statList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    getPostList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/position").then(res => {
        console.log("HERE: ", res);
        if (!res.error) {
          this.postList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    getDeptList() {
      //get dept list
      this.$http.get(":9992/api/v1/admin/dept").then(res => {
        // console.log(res);
        if (!res.error) {
          this.deptList = res.message;
        } else {
        }

        console.log(this.deptList);
      });
    },
    getRoleList() {
      //get role list
      this.$http.get(":9992/api/v1/admin/roles").then(res => {
        // console.log(res);
        if (!res.error) {
          this.rolesList = res.message;
        } else {
        }
      });
    },
    getMangerList() {
      //get role list
      this.$http.get(":9992/api/v1/admin/user/managers").then(res => {
        console.log("MANAGER: ", res);
        if (!res.error) {
          res.message.filter((a, i) => {
            console.log(a.posname);
            if (a.posname == "ALL") {
              this.sorokRoot = a;
              console.log([i]);
              res.message.splice(i, 1);
            }
          });
          this.allPosition = res.message;
          console.log(res.message);
          this.managerList = this.allPosition;
        } else {
        }
      });
    }
  }
};
</script>
<style lang="scss">
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
